import { useCallback } from 'react';

import { useGlobalKeyboardHandlerTogglers } from '../../contexts/global-keyboard-handler-togglers';
import { KeyboardKeysType } from '../../types/keyboard-keys';

export const useTurnOffGlobalKeyboardHandlers = () => {
    const globalKeyboardHandlerTogglers = useGlobalKeyboardHandlerTogglers();

    return useCallback(
        (keys: KeyboardKeysType | KeyboardKeysType[]) => {
            if (Array.isArray(keys)) {
                keys.forEach((key) => {
                    globalKeyboardHandlerTogglers[key] = false;
                });
                return;
            }

            globalKeyboardHandlerTogglers[keys] = false;
        },
        [globalKeyboardHandlerTogglers]
    );
};
